module.exports = __webpack_public_path__ + "img/avatar-05.0d19a685.png";